import moment from 'moment';

export const zeroTime = moment(0);

export const getMomentToZero = (date) =>
  moment(date).toDate().getTime() < 0 ? zeroTime : moment(date);

export const getTimeElapsedToDate = (
  date = moment(),
  { timeLimit = 120, typeOfTimeLimit = 'seconds' }
) => moment(moment(date).add(timeLimit, typeOfTimeLimit).diff(moment())).toDate().getTime();

export const getTimeElapsedDefault = ({ timeLimit, typeOfTimeLimit }) =>
  moment(getTimeElapsedToDate(undefined, { timeLimit, typeOfTimeLimit }));
